import useFeatureAccesses from '~/src/hooks/useFeatureAccesses';
import useGetTemplateMetadata from '~/src/hooks/useGetTemplateMetadata';
import { getRegion, Region } from '~/src/regions/config/utils';
import { useSubscription } from '~/src/entities/subscription';

/**
 * Determines whether to show the Court Forms tab based on region and available forms.
 *
 * - US region: Shows only for UP customers who have court forms enabled or additional regions
 * - Non-US regions: Shows if templateMetadata.filter_categories has regional court forms
 */
const useShowCourtFormsTabs = (): boolean => {
  const featureAccesses = useFeatureAccesses();
  const { data: templateMetadata } = useGetTemplateMetadata();
  const { data: subscriptionData } = useSubscription();
  const region = getRegion();

  const hasAdditionalRegions =
    !!subscriptionData?.additional_court_form_regions?.length;

  if (region === Region.US) {
    return (
      !!featureAccesses.isUnifiedPlatform &&
      (!!featureAccesses.isCourtFormsEnabled || hasAdditionalRegions)
    );
  }

  // Non-US regions: check if regional court forms exist
  const hasRegionalCourtForms =
    templateMetadata &&
    templateMetadata.filter_categories &&
    Object.keys(templateMetadata.filter_categories).length > 0;

  return !!hasRegionalCourtForms;
};

export default useShowCourtFormsTabs;
